module.exports = [
	'Mr', 
	'Mrs', 
	'Ms', 
	'Miss'
]


//////////////////
// WEBPACK FOOTER
// ../server/constants/pronouns.js
// module id = 1195
// module chunks = 0